export default function digit(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const splitted = String(value).split('-');

  if (splitted.length !== 2) {
    return true;
  }

  return !!splitted.filter(side => side.trim().length < 1).length;
}

digit.message = function message(value, options = {}) {
  return options.message || 'dígito obrigatório. exemplo: 123-4';
};
